import React from "react";
import first from "../assets/images/LowDamage/1.gif";
import second from "../assets/images/LowDamage/2.png";
import ResponsiveEmbed from "react-responsive-embed";


const Index = props => {
  return (
      <div className="c-content-box">
        <h2>Progetto a basso danneggiamento</h2>
          <div style={{ textAlign: 'justify', lineHeight: '2em'}}>

          <img src={first} style={{ width: '100%', height: '100%' }} />

          Traducendo testualmente le parole nel PRESS Design Handbook (Pampanin et al., 2010): "Negli ultimi dieci anni si sono osservati grandi progressi nell'ingegneria sismica con ulteriori affinamenti del performance-based design e la definizione dei corrispondenti stati limite. Seguendo le aspettative modiali e l'obiettivo ideale di una società con strutture dalle alte prestazioni (sismiche) e capaci di sostenere il terremoto di progetto con danno limitato o trascurabile,
          sono state sviluppate soluzioni simo-resistenti poco costose e altamente performanti, basate su una combinazione di materiali tradizionali e tecnologie a disposizione." <br /> <br />

          <h3>Il sistema PRESSS</h3>
          "Una di queste è il PREcast Seismic Structural System (PRESSS), sviluppato alla University of California, San Diego (Priestley, 1991, 1996; Priestley et al. 1999). In questo sistema sono presenti elementi strutturali prefabbricati sono collegati attraverso cavi o barre post tese e non ancorate. La domanda inelastica è concentrata nelle connessioni stesse (trave-colonna, colonna-fondazione o muro-fondazione), attraverso l'apertura e chiusura di gap nelle interfacce (rocking), mentre un livello particolarmente basso di danno si concentra negli elementi strutturali, se comparato alle soluzioni gettate in opera." <br /> <br />

          <img src={second} style={{ width: '100%', height: '100%' }} />

          <h3>La mia esperienza</h3>
          Ho avuto l'incredibile opportunità di imparare a progettare questo tipo di strutture in un corso alla ROSE school di Pavia, chiamato "Seismic Design of Low-Damage Concrete and Timber Buildings", tenuto dal professor Stefano Pampanin. <br /> <br />

          <ResponsiveEmbed src='https://www.youtube.com/embed/X9vDWHWCoik' allowFullScreen />
          <ResponsiveEmbed src='https://www.youtube.com/embed/xazfxid0DAE' allowFullScreen />

        </div>
      </div>
  );
};

export default Index;



// WEBPACK FOOTER //
// ./src/pages/lowdamage.it.jsx